import type { ArrayValueType } from '@vedalib/editor'

import { DEFAULT_GRID_ITEMS } from '../../constants'
import type { ISizeValue } from '../Size/types'
import { applySize } from '../Size/utils'
import type { GridValueType } from './types'

type LikeGridValueType = Omit<GridValueType, 'items'> & {
  items: (ISizeValue | null)[] | ArrayValueType<ISizeValue | null>[]
}

export const safeParseGrid = (value?: string): GridValueType => {
  try {
    return JSON.parse(value || DEFAULT_GRID_ITEMS())
  } catch {
    return JSON.parse(DEFAULT_GRID_ITEMS())
  }
}

export const applyGrid = (value?: LikeGridValueType | string): string => {
  const { items, min } = typeof value === 'string' ? safeParseGrid(value) : value || safeParseGrid()

  return items
    .map((s) => {
      const size = s && 'data' in s ? s?.data : s
      const pxSize = size?.unit === 'px' ? size.value : null
      const base = Math.min(min || 0, pxSize || Infinity)
      return `minmax(${base}px, ${applySize(size) || 'auto'})`
    })
    .join(' ')
}

export const saveGrid = (value: GridValueType) => JSON.stringify(value)
